export function runWhenIdle(callback: () => void, timeout = 2000) {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout });

    return;
  }

  setTimeout(callback, timeout);
}
